import { render, staticRenderFns } from "./MinusCircle.vue?vue&type=template&id=66b61a00&scoped=true&"
import script from "./MinusCircle.vue?vue&type=script&lang=js&"
export * from "./MinusCircle.vue?vue&type=script&lang=js&"
import style0 from "./MinusCircle.vue?vue&type=style&index=0&id=66b61a00&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b61a00",
  null
  
)

export default component.exports